import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Login({ onLogin }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('demo@khepri.ru');
  const [password, setPassword] = useState('demo123');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (!validateEmail(email)) {
      setError('Введите корректный email');
      setLoading(false);
      return;
    }

    if (mode !== 'reset' && password.length < 6) {
      setError('Пароль должен быть не менее 6 символов');
      setLoading(false);
      return;
    }

    try {
      if (mode === 'login') {
        const res = await fetch(API + '/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || 'Ошибка входа');
        onLogin(data.token, data.user);
      } else if (mode === 'register') {
        const res = await fetch(API + '/auth/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password, name: name || 'Пользователь', company: company || 'Моя компания', tax_regime: 'УСН' }),
        });
        const data = await res.json();
        if (!res.ok) {
          if (data.detail === 'Email already registered') {
            throw new Error('Этот email уже зарегистрирован. Войдите или восстановите пароль.');
          }
          throw new Error(data.detail || 'Ошибка регистрации');
        }
        setSuccess('✅ Регистрация успешна! Теперь войдите.');
        setMode('login');
        setPassword('');
      } else if (mode === 'reset') {
        setSuccess('✅ Инструкция по восстановлению отправлена на ' + email);
        setMode('login');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0F172A', padding: 16 }}>
      <div style={{ background: '#1E293B', padding: 40, borderRadius: 12, border: '1px solid #8A6636', width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <h1 style={{ fontSize: 32, marginBottom: 8, color: '#F7DE8A', fontWeight: 700 }}>Khepri</h1>
        <p style={{ color: '#94A3B8', marginBottom: 24, fontSize: 14 }}>Операционная система для бизнеса</p>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20, justifyContent: 'center' }}>
          <button type="button" onClick={() => { setMode('login'); setError(''); setSuccess(''); }} style={{ padding: '8px 20px', borderRadius: 20, border: mode === 'login' ? 'none' : '1px solid #8A6636', background: mode === 'login' ? '#F7DE8A' : 'transparent', color: mode === 'login' ? '#0F172A' : '#94A3B8', cursor: 'pointer', fontWeight: 600 }}>
            Вход
          </button>
          <button type="button" onClick={() => { setMode('register'); setError(''); setSuccess(''); }} style={{ padding: '8px 20px', borderRadius: 20, border: mode === 'register' ? 'none' : '1px solid #8A6636', background: mode === 'register' ? '#F7DE8A' : 'transparent', color: mode === 'register' ? '#0F172A' : '#94A3B8', cursor: 'pointer', fontWeight: 600 }}>
            Регистрация
          </button>
        </div>

        {mode === 'reset' && (
          <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 12 }}>
            Введите email — мы отправим инструкцию по восстановлению пароля.
          </p>
        )}

        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <>
              <input style={inputStyle} type="text" placeholder="Имя" value={name} onChange={e => setName(e.target.value)} />
              <input style={inputStyle} type="text" placeholder="Компания" value={company} onChange={e => setCompany(e.target.value)} />
            </>
          )}
          <input style={inputStyle} type="email" placeholder="Электронная почта" value={email} onChange={e => setEmail(e.target.value)} required />
          {mode !== 'reset' && (
            <input style={inputStyle} type="password" placeholder="Пароль (минимум 6 символов)" value={password} onChange={e => setPassword(e.target.value)} required />
          )}
          {error && <p style={{ color: '#EF4444', fontSize: 13, marginBottom: 8 }}>{error}</p>}
          {success && <p style={{ color: '#10B981', fontSize: 13, marginBottom: 8 }}>{success}</p>}
          <button style={{ width: '100%', padding: 14, background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer', marginTop: 8 }} type="submit" disabled={loading}>
            {loading ? 'Загрузка...' : mode === 'login' ? 'Войти' : mode === 'register' ? 'Зарегистрироваться' : 'Отправить инструкцию'}
          </button>
        </form>

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
          <button type="button" onClick={() => { setMode('reset'); setError(''); setSuccess(''); setPassword(''); }} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
            Забыли пароль?
          </button>
        </div>

        <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 16 }}>Демо: demo@khepri.ru / demo123</p>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: 12,
  marginBottom: 12,
  background: '#0F172A',
  border: '1px solid #8A6636',
  borderRadius: 8,
  color: '#F8FAFC',
  fontSize: 14,
};

export default Login;